import { render } from "./OpenResponseQuestionWithFeedback.vue?vue&type=template&id=d4b72f24"
import script from "./OpenResponseQuestionWithFeedback.vue?vue&type=script&lang=js"
export * from "./OpenResponseQuestionWithFeedback.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__